import { type FC } from "react";

import { Hotkeys } from "@moment/design-system/Hotkeys";
import { BasicTooltip, type BasicTooltipProps } from "@moment/design-system/Tooltip";

import { type hotkeyCommands, hotkeys } from "~/utils/hotkeys";

export type HotKeyTooltipProps = Omit<BasicTooltipProps, "content"> & {
	hotkeyName: (typeof hotkeyCommands)[number];
	description?: string;
};
export const HotKeyTooltip: FC<HotKeyTooltipProps> = ({
	hotkeyName,
	description,
	children,
	...rest
}) => {
	const hotkey = hotkeys[hotkeyName];
	const content = (
		<span className="space-x-2">
			<span>{description || hotkey.description}</span>
			<Hotkeys hotkey={hotkey.prettyPrintKeybinding()} />
		</span>
	);

	return (
		<BasicTooltip content={content} {...rest}>
			{children}
		</BasicTooltip>
	);
};
